import { useMutation } from "@apollo/client";
import { Alert, Button, Link, Stack } from "@mui/material";
import { gql } from "generated-graphql";
import { Link as RouterLink } from "react-router-dom";

export const CREATE_CERS_REVISION = gql(`
  mutation CreateCersRevision($findingId: ID!) {
    createCersRevision(findingId: $findingId) {
      alreadyOpen
      report {
        id
      }
    }
  }
`);

type Props = {
  findingId: string;
  isFacilityMatched: boolean;
  cersFacilityId: string;
};

// TODO: confirm this path once the staff CERS facility-matching screen ships.
const matcherPath = (cersFacilityId: string) => `/staff/cers/facilities?focus=${cersFacilityId}`;

// Route confirmed: /staff/fulfillment/r/:reportId (ReportDetails in main.tsx).
const reportPath = (reportId: string) => `/staff/fulfillment/r/${reportId}`;

export function CreateRevisionAction({ findingId, isFacilityMatched, cersFacilityId }: Props) {
  const [createRevision, { data, loading, error }] = useMutation(CREATE_CERS_REVISION, {
    variables: { findingId },
    onError: () => undefined,
  });

  if (!isFacilityMatched) {
    return (
      <Stack spacing={1}>
        <Alert severity="warning">
          This CERS facility isn&apos;t matched to an Encamp facility yet — match it first.{" "}
          <Link component={RouterLink} to={matcherPath(cersFacilityId)}>
            Match facility
          </Link>
        </Alert>
        <Button variant="contained" disabled>
          Create revision
        </Button>
      </Stack>
    );
  }

  const result = data?.createCersRevision;

  return (
    <Stack spacing={1}>
      {error && <Alert severity="error">{error.message}</Alert>}
      {result && (
        <Alert severity="success">
          {result.alreadyOpen
            ? "Linked to the existing open revision."
            : "Revision report created."}{" "}
          <Link component={RouterLink} to={reportPath(result.report.id)}>
            View revision
          </Link>
        </Alert>
      )}
      {!result && (
        <Button variant="contained" disabled={loading} onClick={() => void createRevision()}>
          Create revision
        </Button>
      )}
    </Stack>
  );
}
